<template>
  <section class="teacher-landing-container">
    <div class="container">
      <div class="teacher-landing-container--grid">
        <div class="grid--teacher-description">
          <p class="paragraph">
            <b>KINF's Supply A Teacher</b> program seeks
            to remove the burden of having to provide
            necessary resources from teachers in
            underserved schools. With each Supply A
            Teacher box we deliver, a teacher receives
            items they need to fuel a full semester of
            active learning for their entire class of
            students, whether they are teaching in
            the classroom or via distance learning.
          </p>

          <p class="paragraph">
            Applications are open to teachers
            at schools where 50% or more of students are
            enrolled in the National School Lunch
            Program.
          </p>

          <p class="paragraph">
            Applications and awards will be accepted
            year-round, so teachers, don't miss out!
          </p>
        </div>
        <div class="grid--teacher-form">
          <h2 class="title-2 text-center partner-title">
            Please enter your name and <br/>
            email address to apply
          </h2>

          <form @submit.prevent="handleSubmit" novalidate>
            <div class="input-group">
              <input
                type="text"
                v-model="name"
                class="input-field fa-placeholder"
                @input="$v.name.$touch()"
                placeholder="John Doe"
                :class="{ 'warning': $v.name.$anyError }"
                required
              >

              <span class="span-awesome">
                <i class="fal fa-user" />
              </span>

              <transition name="fade">
                <warning-alert v-if="$v.name.$anyError">
                  This field is required
                </warning-alert>
              </transition>
            </div>

            <div class="input-group">
              <input
                type="email"
                v-model="email"
                class="input-field fa-placeholder"
                placeholder="johndoe@mail.com"
                @input="$v.email.$touch()"
                :class="{ 'warning': $v.email.$anyError }"
                required
              >

              <span class="span-awesome">
                <i class="fal fa-envelope" />
              </span>
              <transition name="fade">
                <warning-alert v-if="$v.email.$anyError && !$v.email.required">
                  This field is required
                </warning-alert>
                <warning-alert v-if="$v.email.$anyError && !$v.email.email">
                  This field needs to be an email
                </warning-alert>
              </transition>
            </div>

            <button type="submit" class="btn btn-teacher-form" :disabled="isSubmitting">
              <span v-if="!isSubmitting">
                CONTINUE
              </span>
              <span v-else>
                <i class="fas fa-spin fa-spinner" />
                PROCESSING
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import WarningAlert from '../TeachersForm/components/WarningAlert'
import Axios from 'axios'

export default {
  name: 'TeacherLanding',
  mixins: [validationMixin],
  components: {
    WarningAlert
  },
  data () {
    return {
      name: null,
      email: null,
      isSubmitting: false
    }
  },
  methods: {
    async handleSubmit () {
      this.touchForm()
      if (this.$v.$anyDirty && !this.$v.$anyError && !this.isSubmitting) {
        this.isSubmitting = true

        const response = await Axios({
          url: '/teachers/validateNewTeacher',
          method: 'POST',
          data: {
            name: this.name,
            email: this.email
          }
        })

        if (response.data.mailIsAlreadyUser) {
          window.location.href = '/teachers/login'
        } else if (!response.data.mailIsAlreadyUser && response.data.logged) {
          window.location.href = '/teachers/information'
        }
      }
    },
    touchForm () {
      this.$v.name.$touch()
      this.$v.email.$touch()
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    }
  }
}
</script>

<style lang="scss" scoped>
.input-group {
  margin-bottom: 20px;
  display: block;
  margin: 0 auto;
  width: 100%;
  margin-bottom: 2rem !important;

  .input-field {
    padding-left: 50px;
    max-width: 100% !important;
    border-width: 1px;
    margin-bottom: 0 !important;
  }

  span.span-awesome {
    font-size: 16px;
    position: absolute;
    top: 15px;
    left: 20px;
    color: #6D6E71;
  }

  @media(min-width: 1200px) {
    max-width: 410px !important;

    .input-field {
      padding-left: 50px;
    }

    span.span-awesome {
      left: 20px;
    }
  }

  // @media (min-width: 1500px) {
  //   span.span-awesome {
  //     left: 166px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// resources/js/views/homepage/TeacherLanding.vue